export default __webpack_public_path__ + "static/BOOOM-6fe91f90edd2b9926f9a7090dd2c6446.jpeg";